export default "__VITE_ASSET__EQIBt5vt__"